import type {
  RorosQcReportDTO,
  FttSummary,
  FttDomainDetail,
  CreateQcReportPayload,
} from '@/types/roros/quality';
import { fetchJson, mutate, qs } from './base-roros.service';

// ─── Quality ────────────────────────────────────────────────────────────────

export const RorosQualityService = {
  createReport: (payload: CreateQcReportPayload) =>
    mutate<RorosQcReportDTO>('/api/v1/quality/reports', 'POST', payload),
  listReports: (params?: Record<string, string>) =>
    fetchJson<RorosQcReportDTO[]>(`/api/v1/quality/reports${qs(params)}`),
  getReport: (id: string) =>
    fetchJson<RorosQcReportDTO>(`/api/v1/quality/reports/${id}`),
  getFttSummary: (params?: Record<string, string>) =>
    fetchJson<FttSummary>(`/api/v1/quality/ftt${qs(params)}`),
  getFttByDomain: (domainId: string) =>
    fetchJson<FttDomainDetail>(`/api/v1/quality/ftt/${domainId}`),
};
